import token_mutations, { token_mutation_keys } from "./token";
import user_mutations, { user_mutation_keys } from "./user";
import app_mutations, { app_mutation_keys } from "./app";
import layout_mutations, { layout_mutation_keys } from "./layout";
import account_mutations, { account_mutation_keys } from "./account";
import sidebar_mutations, { sidebar_mutation_keys } from "./sidebar";

/** Mutations keys */
const mutation_keys = {
    token: token_mutation_keys,
    user: user_mutation_keys,
    app: app_mutation_keys,
    layout: layout_mutation_keys,
    account: account_mutation_keys,
    sidebar: sidebar_mutation_keys
};

/**
 * Default mutations
 * @type {import("../types/mutations").DefaultMutations}
 */
const default_mutations = {
    ...token_mutations,
    ...user_mutations,
    ...app_mutations,
    ...layout_mutations,
    ...account_mutations,
    ...sidebar_mutations
}

export { mutation_keys };

export default default_mutations;